import FootballCountryModel from "../Country/FootballCountryModel";

export default class PlayerMarketResultModel {
    public id: string = null;
    public name: string = null;
    public country: FootballCountryModel = null;
}